
import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {Response} from "../../classes/response";
import {UserResponse} from "../../classes/user-response";

@Component({
  selector: 'text-area-type',
  templateUrl: './text-area-type.component.html',
  styleUrls: ['./text-area-type.component.css']
})
export class TextAreaTypeComponent implements OnInit{

  //self explanatory

  @Input() question_index : number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() question_max_char : number;
  @Input() is_mandt : boolean;
  @Input() userRes : string[];
  @Input() question_number : number;
  @Output() user_Resp = new EventEmitter<string[]>();
  @Input() indexOfRepeater : number;

  response : string;

  constructor(){
  }

  ngOnInit(){
    this.response = this.userRes[this.indexOfRepeater];
  }

  entered($event : any){
    this.response = $event.target.value;
    this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
  }
}



// WEBPACK FOOTER //
// ./src/app/questions-type/text-area-type/text-area-type.component.ts